import {ChangeDetectorRef, Component, HostListener, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { User } from '@app/models/user';
import { AuthenticationService } from "@app/services/authentication.service";
import { TranslateConfigService } from '@app/services/translate-config.service';
import { AuthorizationService } from "@app/services/authorization.service";
import { UserService } from "@app/services/user.service";


@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.css'],
    standalone: false
})
export class NavbarComponent implements OnInit {

  public currentUser: User;
  username: string;
  currentLanguage: string;
  id: string;
  link: string;
  defaultAvatar: string = '../../../assets/img/avatar.png';
  imgSrc: string | ArrayBuffer ;
  buildVersion:string = '3.6.9';
  languages: any[] = [];
  dropdownOpen = false;
  private readonly langKey: string = 'lang';

  constructor(private translateConfigService: TranslateConfigService,
    private authenticationService: AuthenticationService,
    private authorizationService: AuthorizationService,
    private router: Router,
    private userService: UserService,
    private cdRef: ChangeDetectorRef)
  {  }

  ngOnInit(): void {
    let loginInfo = this.authenticationService.getCurrentUserInfo();
    if (loginInfo && loginInfo.jti) {
      this.currentUser = new User();
      this.currentUser.username = loginInfo.sub;
      this.currentUser.id = loginInfo.jti;
      this.link = '/user/settings/'+ this.currentUser.id;
      this.downloadFile(this.currentUser.id);
      this.username = loginInfo.sub;
    } else {
      this.logout();
    }
    this.currentLanguage = localStorage.getItem(this.langKey) || this.translateConfigService.getCurrentLanguage();

    this.getExistingLanguages();
  }
  toggleDropdown(event: Event): void {
    event.stopPropagation();
    this.dropdownOpen = !this.dropdownOpen;
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event): void {
    const clickedInside = (event.target as HTMLElement).closest('.nav-item.dropdown');
    if (!clickedInside) {
      this.dropdownOpen = false;
    }
  }

  changeLanguage(languageKey: string): void {
    this.translateConfigService.changeLanguage(languageKey);
    this.currentLanguage = this.translateConfigService.getCurrentLanguage();
  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }

    toMainPage() {
      if (this.authorizationService.isAdmin()) {
        this.router.navigate(['/admin']);
      } else {
        this.router.navigate(['/user/customers']);
      }
    }

  downloadFile(id) {
      this.userService.download(id).subscribe({
        next: (blob) => {
          if(!(blob instanceof Blob)){
            this.imgSrc = this.defaultAvatar;
          }else {
            let reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => {
              let base64data = reader.result as string;
              this.imgSrc = base64data.replace('data:application/octet-stream;', 'data:image/png;');
              this.cdRef.detectChanges();
            }
          }
        },
        error: () => {
          this.imgSrc = this.defaultAvatar;
          this.cdRef.detectChanges();
        }
      });
  }

  getExistingLanguages(): void {
    this.translateConfigService.loadLanguages().subscribe(
        (data) => {
          this.languages = data.languages;
        },
        (error) => {
          console.error('Error loading languages', error);
        })
  }

}
